"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EOpportunityCustomerInfoSource = exports.EOpportunityInfoType = exports.EOfferType = exports.EOpportunityProgress = exports.EOpportunityState = void 0;
var EOpportunityState;
(function (EOpportunityState) {
    EOpportunityState["OPEN"] = "O";
    EOpportunityState["CLOSED"] = "C";
    EOpportunityState["POSTPONED"] = "P";
})(EOpportunityState = exports.EOpportunityState || (exports.EOpportunityState = {}));
var EOpportunityProgress;
(function (EOpportunityProgress) {
    EOpportunityProgress["RESERVATION"] = "R";
    EOpportunityProgress["SALE"] = "S";
    EOpportunityProgress["OFFER"] = "O";
    EOpportunityProgress["CONTRACT"] = "C";
    EOpportunityProgress["CREATED"] = "X";
})(EOpportunityProgress = exports.EOpportunityProgress || (exports.EOpportunityProgress = {}));
var EOfferType;
(function (EOfferType) {
    EOfferType["FINANCE"] = "F";
    /** "Leasing mit Kilometerabrechnung" */
    EOfferType["LEASING"] = "L";
    /** "Restwertleasing" */
    EOfferType["RESIDUAL_LEASING"] = "R";
    EOfferType["CASH"] = "C";
})(EOfferType = exports.EOfferType || (exports.EOfferType = {}));
var EOpportunityInfoType;
(function (EOpportunityInfoType) {
    EOpportunityInfoType["OFFER_RESPONSE"] = "OFFER_RESPONSE";
    EOpportunityInfoType["NOTE"] = "NOTE";
    EOpportunityInfoType["EVENT"] = "EVENT";
    EOpportunityInfoType["RESERVATION"] = "RESERVATION";
    EOpportunityInfoType["SALE"] = "SALE";
    EOpportunityInfoType["AVAILABLE"] = "AVAILABLE";
    EOpportunityInfoType["TEMPLATE"] = "TEMPLATE";
})(EOpportunityInfoType = exports.EOpportunityInfoType || (exports.EOpportunityInfoType = {}));
var EOpportunityCustomerInfoSource;
(function (EOpportunityCustomerInfoSource) {
    EOpportunityCustomerInfoSource["OFFER"] = "OFFER";
})(EOpportunityCustomerInfoSource = exports.EOpportunityCustomerInfoSource || (exports.EOpportunityCustomerInfoSource = {}));
